import React from 'react'

function AchCard({ title, description, image }) {
    return (
        <div className='achCarousal__card'>
            <div className='achCarousal__left'>
                <img src={image} alt={title} />
            </div>
            <div className='achCarousal__right'>
                <h1>{title}</h1>
                <p>{description}</p>
            </div>
        </div>
    )
}

export default AchCard